<!-- Teo connection with Online info -->
<template>
  <div class="text-muted container">
    <small>
      <div class="name">id: {{ teoname }}</div>
      <div class="name">server: {{ name }}</div>
      <div class="uptime">uptime: {{ uptime }}</div>
      <div class="version">version: {{ version }}</div>
      <div class="clients">clients: {{ clients }}</div>
      <div>
        <a class="online" v-if="online" href="./">online</a>
        <a class="offline" v-else href="./">offline</a>
        <span v-if="connectType" @click="setConnectType()">
          [{{ connectType }}]</span
        >
      </div>
      <button
        v-if="disconnected"
        type="button"
        class="btn btn-sm btn-warning mt-2 mb-2"
        @click="reconnect()"
      >
        Reconnect
      </button>
    </small>
  </div>
</template>

<script>
import { uuid } from "vue-uuid";

// Login 'login;' or API key 'key;' auth method
const authMethod = "login";

// Defalut teoweb commands
const cmdClients = "clients";

// This application teoweb commands
const cmdName = "name";
const cmdUptime = "uptime";
const cmdApiUrl = "api.url";
const cmdVersion = "version";
// const cmdCheckToken = "auth.checktoken";
const cmdLoginUserSet = "login.user.set";

export default {
  name: "TeoWeb",

  emits: ["online"],

  data() {
    return {
      name: "Loading ...",
      teoname: "Loading ...",
      uptime: "0",
      version: "...",
      clients: "0",
      connectType: "",
      online: false,
      disconnected: false,
    };
  },

  mounted: function () {
    this.connect();
    this.connectType = this.teoweb.connectType;
  },

  unmounted: function () {
    this.teoweb.delReader(this.reader);
  },

  methods: {
    setConnectType() {
      if (this.connectType == "webrtc") {
        this.connectType = "ws";
      } else if (this.connectType == "ws") {
        this.connectType = "webtransport";
      } else {
        this.connectType = "webrtc";
      }

      localStorage.setItem("connectType", this.connectType);
      this.reset(this.connectType);
      this.connect();
    },

    /** Connect to Teonet server. */
    connect() {
      const connectType = this.teoweb.connectType;
      const that = this;

      // Get this browser name from local storage
      this.teoname = uuid.v1();
      console.debug("teoname:", this.teoname);

      // Get name and version from local storage
      if (localStorage.name) this.name = localStorage.name;
      if (localStorage.version) this.version = localStorage.version;

      // Connect to Teonet proxy WebRTC server

      // Webrtc Server name
      // The server_name is defined in global variable server_name.
      // The server_name stored in server_name_sample.js file.
      // To change server_name copy file server_name_sample.js to server_name.js
      // and update the server_name constant.
      const serverName =
        connectType == "ws" ? this.server_name_ws : this.server_name;
      console.debug("server name:", serverName);

      // This server scheme, host and path
      let scheme = "wss";
      if (connectType == "webtransport") {
        scheme = "https";
      }

      // This server path
      let path = "";
      switch (connectType) {
        case "ws":
          path = "/ws";
          break;
        case "webrtc":
          path = "/signal";
          break;
        case "webtransport":
          path = "/wt";
          break;
      }

      // This server host
      let host = "";
      switch (connectType) {
        case "ws":
          host = "teo-ws-proxy.teonet.app";
          break;
        case "webrtc":
          host = "signal.teonet.dev";
          break;
        case "webtransport":
          host = this.server_name_wt;
          break;
      }

      // Connect to Teonet WebRTC server or WebSocket proxy server
      this.teoweb.connect(
        scheme + "://" + host + path,
        this.teoname,
        serverName
      );

      // Listen for teoweb on open event
      this.teoweb.onOpen(async function () {
        // Make it async to use await
        console.debug("TeoConnect: connection opened.");

        // Set online
        that.online = true;
        that.disconnected = false;

        // Send emit online event
        that.$emit("online", true);

        // Fetch and set the global API URL
        const getApiUrl = async () => {
          try {
            console.log("TeoConnect: Fetching API URL...");
            const apiUrl = await that.sendCmd(cmdApiUrl);
            if (apiUrl && typeof apiUrl === "string") {
              that.$globalState.apiUrl = apiUrl.trim();
              console.log(
                "TeoConnect: Global API URL set to:",
                that.$globalState.apiUrl
              );
            } else {
              console.error("TeoConnect: Received invalid API URL:", apiUrl);
              that.$globalState.apiUrl = ""; // Fallback to empty string
              setTimeout(getApiUrl, 100);
            }
          } catch (error) {
            console.error("TeoConnect: Failed to fetch API URL:", error);
            that.$globalState.apiUrl = ""; // Fallback to empty string on error
            setTimeout(getApiUrl, 100);
          }
        };
        getApiUrl();

        // Set login information for API key auth method
        if (authMethod == "key") {
          let userkey = localStorage.userkey || sessionStorage.userkey;
          that.teoweb.sendCmd(cmdLoginUserSet, userkey);
        }

        // Request connect component data from server
        console.debug("TeoConnect: Requesting connect component data...");
        that.teoweb.sendCmd(cmdName);
        that.teoweb.sendCmd(cmdUptime);
        that.teoweb.sendCmd(cmdVersion);
        that.teoweb.sendCmd(cmdClients);
        that.teoweb.subscribeCmd(cmdClients);
      });

      // Listen for WebRTC on close event
      this.teoweb.onClose(function (b) {
        console.debug("connect onclose");

        // Set offline
        that.online = false;
        if (b === true) {
          that.disconnected = true;
          // that.reconnect();
        }

        // Send emit online event
        that.$emit("online", false);
      });

      // Listen for answer data from server
      this.teoweb.addReader(function (gw, data) {
        switch (gw.command) {
          case cmdClients:
            that.clients = data;
            break;

          case cmdName:
            that.name = data;
            localStorage.name = that.name;
            break;

          case cmdVersion:
            that.version = data;
            localStorage.version = that.version;
            break;

          case cmdUptime:
            that.uptime = data;
            break;

          // Got login user answer for the API key login method
          // Depricated: All this checking moved to SingIn component and this
          // component is not needed after test.

          // case cmdCheckToken:
          // case cmdLoginUserSet:
          //   that.teoweb.token = data;
          //   console.debug("logged in:", data);
          //   break;
        }
      });
    },

    /** Reconnect to Teonet server */
    reconnect() {
      // TODO: Implement reconnect or Update teoweb
      location.reload();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.online {
  color: #42b983 !important;
}
.offline {
  color: red !important;
}

.online,
.offline {
  text-decoration: none;
}

.connectType {
  color: #ffc107;
}
</style>
